type SignupState = 'emailInput' | 'emailVerify' | 'createAccount'

interface StateTransitions {
  [key: string]: SignupState[]
}

export const useSignupStateMachine = () => {
  const currentState = ref<SignupState>('emailInput')
  
  const transitions: StateTransitions = {
    emailInput: ['emailVerify'],
    emailVerify: ['createAccount', 'emailInput'],
    createAccount: ['emailInput']
  }
  
  const isValidTransition = (from: SignupState, to: SignupState): boolean => {
    return transitions[from]?.includes(to) ?? false
  }
  
  const transition = (newState: SignupState): boolean => {
    if (isValidTransition(currentState.value, newState)) {
      currentState.value = newState
      return true
    }
    console.warn(`Invalid transition from ${currentState.value} to ${newState}`)
    return false
  }
  
  const isState = (state: SignupState): boolean => {
    return currentState.value === state
  }
  
  const reset = () => {
    currentState.value = 'emailInput'
  }
  
  return {
    currentState: readonly(currentState),
    transition,
    isState,
    reset,
    isValidTransition
  }
}